import { render, staticRenderFns } from "./DatepickerInput.vue?vue&type=template&id=20dda365"
import script from "./DatepickerInput.vue?vue&type=script&lang=js"
export * from "./DatepickerInput.vue?vue&type=script&lang=js"
import style0 from "./DatepickerInput.vue?vue&type=style&index=0&id=20dda365&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports